import { server_ip } from "../config";

export async function fetchNotifications( token, filter, options) {
    try {
        const response = await fetch(`${server_ip}/api/notifications/fetch`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                filter,
                options,
            })
        });
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' };
    }
}

export async function deleteNotificationById(token, id) {
    try {
        const response = await fetch(`${server_ip}/api/notifications/${id}`, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' };
    }
}